<template>
    <div class="property-listing list_view style_new " :class="border ? 'border rounded' : ''">
        <div class="listing-img-wrapper position-relative">
            <div class="like_unlike_prt">
                <label class="toggler toggler-danger"><input type="checkbox"><i class="fa fa-heart"></i></label>
            </div>
            <div class="list-img-slide">
                <img :src="`${item.logo}`" class="img-fluid" alt="hall logo" :style="{height: height}" />           
            </div>
        </div>
        
        <div class="list_view_flex">
            <div class="listing-detail-wrapper mt-1">
                <div class="listing-short-detail-wrap">
                    <div class="_card_list_flex mb-2">
                        <div class="_card_flex_last px-2">
                            <h1 class="listing-name mt-3" style="font-size: 20px;">
                            <router-link :to="localizedHallPath(item)" class="prt-link-detail">{{item.name}}</router-link>
                            </h1>
                        </div>
                    </div>
                    <div class="_card_list_flex px-2">
                        <div class="_card_flex_01">
                            <p v-html="item && item.description  ? item.description  : ''"></p>
                        </div>
                    </div>
                </div>
            </div>            
            <div class="listing-detail-footer mt-2 d-flex flex-column align-items-center justify-content-center w-100">
                <div class="d-flex justify-content-center w-100 mt-3">
                    <router-link
                        :to="localizedHallPath(item)"
                        :class="['custom-btn', 'btn-primary', 'd-flex', 'align-items-center', 'justify-content-center']"
                        >
                        <span class="svg-icon text-light svg-icon-3hx me-2">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>
                                <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor"/>
                            </svg>
                        </span>{{ $t('explore stands') }}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script setup>
import { defineProps } from "vue";
import { useI18n } from "vue-i18n";

const { locale } = useI18n();
const localizedHallPath = (item) => {
  const currentSlug = item.slug?.[locale.value]

  if (!currentSlug) return undefined

  return `/${locale.value}/hall/${currentSlug}`
}
defineProps({
item: Object,
height: String,
border: Boolean
});
</script>
<style scoped>
    .custom-btn {
        padding: 6px 30px;
        font-size: 1rem;
        border-radius: 0.4rem;
    }
</style>
<style>
[dir="rtl"] .custom-btn {
  margin-right: 40px;
}
</style>